export default {
      id: "close-usage",
      viewBox: "0 0 17 16",
      url: __webpack_public_path__ + "img/icons.479460d5.svg#close",
      toString: function () {
        return this.url;
      }
    }